<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月22日 11:02:34 +0800
 * @最后修改时间: 2021-12-14 14:01:31
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\DateSelect.vue
 -->
<template>
  <v-container
    fluid
    class="
      fill-height
      max-width
      pa-0
      d-flex
      flex-row flex-grow-1
      justify-end
      align-end
    "
  >
    <div
      class="
        max-width
        text-start text-block text-truncate
        pl-2
        d-flex
        flex-column
        align-items-end
      "
    >
      <div :class="year.indexOf('-') != -1 ? 'text-caption' : 'text-caption'">
        {{ year }} {{ month }}
      </div>
      <div class="text-caption font-weight-black">
        <!-- 2020-10-16 mel 去掉綠色的點 -->
        <!-- <span class="green--text material-icons-round md-18">brightness_1</span> -->
      </div>
      <div class="max-width d-flex mt-1 align-start pr-2 py-2 mx-n2">
        <v-autocomplete
          v-model="filterStaffs"
          :items="allStaff"
          filled
          rounded
          ref="filterStaff2"
          height="40"
          dense
          :allow-overflow="false"
          hide-details
          :append-icon="
            filterStaffs.length > 0 && !isFocus ? 'search' : 'arrow_drop_down'
          "
          single-line
          :placeholder="
            $t('label_essweb_leaveBalance_list_staffNameLabel') +
            '/' +
            $t('label_essweb_leaveBalance_list_staffIdLabel')
          "
          @focus="isFocus = true"
          @blur="toFocus"
          chips
          :readonly="isReadOnly"
          :open-on-clear="false"
          class="py-2 spacial-v-autocomplete"
          multiple
          :filter="$staffFilter"
          item-text="staff_code"
          item-value="staff_id"
          @click:append="
            filterStaffs.length > 0 && !isFocus ? toSearch() : null
          "
        >
          <!-- <template v-slot:append>
            <span
              class="material-icons-round text--secondary"
              v-if="filterStaffs.length > 0"
              @click="toSearch"
            >
              search
            </span>
          </template> -->
          <template v-slot:no-data>
            <noContent />
          </template>
          <template v-slot:prepend-item v-if="allStaff.length > 0">
            <v-list-item
              dense
              class="px-4"
              @click="
                $nextTick(() => {
                  if (filterStaffs.length === allStaff.length) {
                    filterStaffs = [];
                    $refs.filterStaff2.blur();
                    $emit('search', null);
                  } else {
                    $refs.filterStaff2.blur();
                    filterStaffs = [];
                    allStaff.map((item) => {
                      filterStaffs.push(item.staff_id);
                    });
                  }
                })
              "
            >
              <v-list-item-action class="mx-0 my-0 mr-1">
                <span
                  class="material-icons-round"
                  :class="
                    filterStaffs.length !== 0 &&
                    filterStaffs.length === allStaff.length
                      ? 'primary--text'
                      : filterStaffs.length > 0 &&
                        filterStaffs.length !== allStaff.length
                      ? 'primary--text'
                      : 'text--secondary'
                  "
                >
                  {{
                    filterStaffs.length !== 0 &&
                    filterStaffs.length === allStaff.length
                      ? "check_box"
                      : filterStaffs.length > 0 &&
                        filterStaffs.length !== allStaff.length
                      ? "indeterminate_check_box"
                      : "check_box_outline_blank"
                  }}
                </span>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{
                    $t("label_essweb_system_select_selectAllLabel")
                  }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              close
              pill
              v-if="data.index < 1"
              class="mx-0 mr-1 pr-2"
              @click:close="removeStaff(data.item)"
            >
              <StaffAvatar
                left
                :src="data.item.staff_avatar"
                :staff_name="data.item.preferred_name"
              />

              <div class="d-inline-block text-truncate" style="max-width: 60px">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </div>
            </v-chip>
            <span v-if="data.index === 1" class="text--primary py-2">
              ...
              {{ filterStaffs.length - 1 }}
              <!-- {{ $t("label_essweb_selection_moreItemLabel") }} -->
            </span>
          </template>
          <template v-slot:item="data">
            <v-list rounded width="100%" nav>
              <v-list-item rouned width="100%" nav two-line dense>
                <v-list-item-avatar class="ma-0 mr-1 white--text" size="36">
                  <StaffAvatar
                    size="36"
                    :src="data.item.staff_avatar"
                    :staff_name="data.item.preferred_name"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2"
                    >{{ $getCommonLangValue(data.item.preferred_name) }}
                    <span class="text--secondary text-caption-xs">{{
                      data.item.staff_code
                    }}</span></v-list-item-title
                  >
                  <v-list-item-subtitle>{{
                    $getCommonLangValue(data.item.job_post_name)
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </v-autocomplete>
      </div>
      <div class="max-width d-flex mt-1 align-start" v-if="0">
        <v-checkbox
          v-model="checked"
          :ripple="false"
          v-if="isEdited"
          :color="isHalf ? 'grey' : ''"
          :readonly="false"
          hide-details
          style="pointer: cursor"
          :indeterminate="isHalf"
          class="mt-0 pt-0 ml-n1"
        >
          <template v-slot:label>
            <span class="text--secondary text-caption">{{
              $t("label_essweb_RosterFormRecord_form_table_staffNameLabbel")
            }}</span>
          </template>
        </v-checkbox>
        <span class="text--secondary text-caption py-1" v-else>{{
          $t("label_essweb_RosterFormRecord_form_table_staffNameLabbel")
        }}</span>
        <v-spacer></v-spacer>
        <v-btn icon v-if="0">
          <span class="material-icons-round">more_vert</span>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "DateSelect",
  props: {
    startTime: { default: "", type: String },
    endTime: { default: "", type: String },
    selectStaffs: { default: [], type: Array },
    allStaffs: { default: [], type: Array },
    isEdited: { default: false, type: Boolean },
    page: { default: 1, type: [String, Number] },
    perpage: { default: 20, type: [String, Number] },
    curFilterStaff: { default: [], type: [String, Array] },
    isActive: { default: 0, type: [String, Number] },
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "AppInfo"]),
    isHalf() {
      if (this.selectStaffs.length == 0) {
        return false;
      } else {
        if (this.selectStaffs.length < this.allStaffs.length) {
          return true;
        }
        if (this.selectStaffs.length == this.allStaffs.length) {
          this.checked = true;
          return false;
        }
      }
    },
    year() {
      if (this.startTime && this.endTime) {
        if (dayjs(this.startTime).year() == dayjs(this.endTime).year()) {
          return dayjs(this.startTime).year().toString();
        } else {
          return (
            dayjs(this.startTime).year() + " - " + dayjs(this.endTime).year()
          );
        }
      } else {
        return "";
      }
    },
    month() {
      if (this.startTime && this.endTime) {
        const startM = dayjs(this.startTime).month();
        const endM = dayjs(this.endTime).month();
        if (startM === endM) {
          return this.$t(this.getMonthKey(startM + 1));
        } else {
          return (
            this.$t(this.getMonthKey(startM + 1)) +
            " - " +
            this.$t(this.getMonthKey(endM + 1))
          );
        }
      } else {
        return "";
      }
    },
  },
  watch: {
    checked(val) {
      this.$emit("onCheckAll", val);
    },
    perpage(val) {
      // this.filterStaffs = []; //reset
    },
    filterStaffs(val, old) {
      // if (val.length == 0) {
      //   this.$emit("search", null);
      // }
    },
    curFilterStaff(val) {
      if (val) this.filterStaffs = val;
    },
    isActive() {
      this.filterStaffs = this.curFilterStaff ? this.curFilterStaff : [];
    },
  },
  data() {
    return {
      checked: false,
      isFocus: false,
      filterStaffs: [],
      allStaff: [],
      isReadOnly: false,
    };
  },
  mounted() {
    this.getAllStaff();
  },
  methods: {
    toFocus() {
      const that = this;
      this.$Sleep(300).then(() => {
        that.isFocus = false;
      });
    },
    toSearch: function () {
      const that = this;
      that.$emit("search", that.filterStaffs);
      if (this.$refs.filterStaff2) {
        this.$refs.filterStaff2.blur();
      }
    },
    getAllStaff: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/get-staff-list/",
        data: {
          type: 2,
        },
      }).then((res) => {
        that.allStaff = res.data;
      });
    },
    removeStaff: function (item) {
      this.filterStaffs = this.filterStaffs.filter(
        (ele) => Number(ele) !== Number(item.staff_id)
      );
      if (this.filterStaffs.length == 0) {
        if (this.$refs.filterStaff2) {
          this.$refs.filterStaff2.blur();
        }
        this.$emit("search", null);
      }
    },
    getMonthKey: function (month) {
      switch (Number(month)) {
        case 1:
          return "label_essweb_system_JanuaryLabel";
          break;
        case 2:
          return "label_essweb_system_FebruaryLabel";
          break;
        case 3:
          return "label_essweb_system_MarchLabel";
          break;
        case 4:
          return "label_essweb_system_AprilLabel";
          break;
        case 5:
          return "label_essweb_system_MayLabel";
          break;
        case 6:
          return "label_essweb_system_JuneLabel";
          break;
        case 7:
          return "label_essweb_system_JulyLabel";
          break;
        case 8:
          return "label_essweb_system_AugustLabel";
          break;
        case 9:
          return "label_essweb_system_SeptemberLabel";
          break;
        case 10:
          return "label_essweb_system_OctoberLabel";
          break;
        case 11:
          return "label_essweb_system_NovemberLabel";
          break;
        case 12:
          return "label_essweb_system_DecemberLabel";
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped></style>
